import React from "react";

import AgraniFooter from "./AgraniFooter";
import CustomNav from "./CustomNav";
import { Link } from "react-router-dom";

const TermsAndConditions = () => {
  return (
    <div className="d-flex flex-column min-vh-100">
      <CustomNav />

      <section
        className="position-relative text-white text-center mt-5"
        style={{
          backgroundImage: "url('/assets/img/bg-imagee.avif')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          padding: "80px 0",
        }}
      >
        <div className="">
          <h1 className="fw-bold display-4 text-orange">TERMS & CONDITIONS</h1>
          <div className="mt-2 d-flex  justify-content-center gap-2">
            <Link to="/" className="text-black">
              Home{" "}
            </Link>{" "}
            <span className="text-black">/</span>
            <p className="text-light"> Terms & Conditions</p>
          </div>

          {/* <ol className="d-flex justify-content-center bg-transparent p-0 m-0">
            <li className="breadcrumb-item">
              <a href="/" className="text-white text-decoration-none">
                Home
              </a>
            </li>
            <li
              className="breadcrumb-item active text-white"
              aria-current="page"
            >
              Terms & Conditions
            </li>
          </ol> */}
        </div>
      </section>
      <main className="container flex-grow-1 mt-5   ">
        <p>
          These Terms and Conditions ("Terms") govern your access to and use of
          the website{" "}
          <a
            href="https://www.leadsconnect.in"
            target="_blank"
            rel="noreferrer"
          >
            www.leadsconnect.in
          </a>{" "}
          (the "Site") and the associated AGRANI applications including AGRANI,
          AGRANI Pro, AGRANI Kisan, and AGRANI Saathi (collectively, the
          “Platform”), operated and managed by LeadsConnect Services Private
          Limited ("LeadsConnect", "we", "us", "our").
        </p>

        <p>
          By accessing, browsing, registering, or using the Platform, you
          ("User" or "you") agree to be bound by these Terms, our{" "}
          <a href="/privacy-policy">Privacy Policy</a>, and any other policies
          or guidelines posted on the Platform. If you do not agree to these
          terms, please do not use our services or access the Platform.
        </p>

        <h5 className="mt-4">1. Use of the Platform</h5>
        <p>
          The Platform facilitates agricultural services, data-driven insights,
          and government scheme access for farmers, field agents, and other
          stakeholders. You agree to use the Platform for lawful purposes only,
          and in a way that does not infringe on the rights of, restrict, or
          inhibit anyone else's use of the Platform.
        </p>

        <h5 className="mt-4">2. Eligibility</h5>
        <p>
          You must be at least 18 years of age to use the Platform
          independently. If you are under 18, you may access the Platform only
          with the involvement of a parent or legal guardian who accepts these
          Terms on your behalf. You must also not be barred from using digital
          services under applicable laws.
        </p>

        <h5 className="mt-4">3. Account Registration</h5>
        <p>
          To access certain features of the Platform, you may be required to
          create an account by submitting personal information such as your
          name, contact details, and location data. You agree that all
          information provided is accurate and up-to-date, and that you will
          maintain the security of your login credentials. LeadsConnect is not
          responsible for unauthorized access due to your failure to safeguard
          your account.
        </p>

        <h5 className="mt-4">4. Data Collection & Privacy</h5>
        <p>
          Our data collection and usage practices are governed by our{" "}
          <a href="/privacy-policy">Privacy Policy</a>. This includes use of
          your name, contact details, geo-location (for features like
          geo-tagging), cookies, and device/browser info. By using the Platform,
          you consent to such collection and use.
        </p>

        <h5 className="mt-4">5. Intellectual Property</h5>
        <p>
          All content, features, and functionality on the Platform — including
          text, graphics, logos, icons, and software — are the intellectual
          property of LeadsConnect or its licensors and are protected by Indian
          and international laws. You may not copy, modify, or reproduce any
          portion of the Platform without our prior written consent.
        </p>

        <h5 className="mt-4">6. Third-party Services</h5>
        <p>
          The Platform may link to or integrate with third-party services (e.g.,
          government schemes, insurance providers). We are not responsible for
          the privacy practices or content of those external websites. Your use
          of such services is subject to their terms and privacy policies.
        </p>

        <h5 className="mt-4">7. Modifications to Terms</h5>
        <p>
          LeadsConnect reserves the right to change or modify these Terms at any
          time. Any changes will be effective immediately upon being posted to
          the Platform. Your continued use of the Platform following such
          changes constitutes your acceptance of the revised Terms.
        </p>

        <h5 className="mt-4">8. Suspension or Termination</h5>
        <p>
          We may suspend or terminate your access to the Platform at our sole
          discretion, without notice, for any violation of these Terms, or for
          other reasons including suspected misuse or fraud.
        </p>

        <h5 className="mt-4">9. Limitation of Liability</h5>
        <p>
          While we strive to ensure accurate and timely information,
          LeadsConnect does not guarantee the completeness or reliability of any
          content or services offered. We are not liable for any direct,
          indirect, or incidental damages arising out of your use of the
          Platform.
        </p>

        <h5 className="mt-4">10. Contact Us</h5>
        <p>
          If you have any questions about these Terms, please contact us via the
          contact information provided on our Platform.
        </p>

        <p className="text-muted mt-4">
          Last updated: <strong>June 26, 2025</strong>
        </p>
      </main>

      <AgraniFooter />
    </div>
  );
};

export default TermsAndConditions;
